import statistics from './statistics';
import mentions from './mentions';

export default function* (){
    yield* [...statistics, ...mentions];
}